import React from 'react';
import { string, bool, func } from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import Typography from 'ggApp/shared/components/typography';
import { AuthModal, FLOW_NAMES } from 'ggApp/modules/auth/v3';
import { getHIWPageUrl } from 'ggApp/utils/path';
import { withDixaMessenger } from 'ggApp/shared/hocs/withDixaMessenger';

import { Wrap, Link, Languages, Stores, Button } from './styled';

class Options extends React.PureComponent {
    createAuthModalRef = (authModal) => {
        this.authModal = authModal;
    };

    openAuthModal = () => {
        if (this.authModal) {
            this.authModal.openModal();
        }
    };

    onContactButtonClicked = () => {
        const { closeMenu, showDixaMessenger } = this.props;
        closeMenu();
        showDixaMessenger();
    };

    render() {
        const {
            className,
            faqsLink,
            isLoggedIn,
            authTK,
            logout,
            closeMenu,
            countryCode,
            storeCode,
            activeLanguage,
            isPartner,
            isBusinessStore,
            requestOfferEnabled,
            newReferralsHostFeatureFlag,
            showDixaMessenger,
        } = this.props;
        let hiwCode = storeCode;
        let external = false;
        const showStudentOfferLink = ['nl', 'de', 'at', 'es'].includes(storeCode);

        if (isPartner) {
            hiwCode = countryCode;
            external = true;
        }
        return (
            <Wrap className={className}>
                {!storeCode.startsWith('business_') ? (
                    <>
                        <Button type="button" onClick={isLoggedIn ? logout : this.openAuthModal}>
                            <Typography tag="label">
                                <Translator tk={authTK} />
                            </Typography>
                        </Button>
                        <Link
                            external={external}
                            to={getHIWPageUrl(hiwCode, activeLanguage)}
                            onClick={closeMenu}
                        >
                            <Typography tag="label">
                                <Translator tk="TIPS_LINKS_HIW_TEXT" />
                            </Typography>
                        </Link>
                        {requestOfferEnabled && (
                            <Button onClick={showDixaMessenger}>
                                <Typography tag="label">
                                    <Translator tk="OFFERINGS_LINKS_REQUEST_OFFER_TEXT" />
                                </Typography>
                            </Button>
                        )}
                        {!isBusinessStore && newReferralsHostFeatureFlag && (
                            <Link external={false} to="/referrals" onClick={closeMenu}>
                                <Typography tag="label">
                                    <Translator tk="PROFILE_LINKS_REFERRALS_TEXT" />
                                </Typography>
                            </Link>
                        )}
                        {showStudentOfferLink && (
                            <Link
                                external={false}
                                to={`https://grover-${storeCode}.connect.studentbeans.com/${storeCode}`}
                                onClick={closeMenu}
                            >
                                <Typography tag="label">
                                    <Translator tk="OFFERINGS_LINKS_STUDENT_BEANS_TEXT" />
                                </Typography>
                            </Link>
                        )}
                        <Link external to={faqsLink} onClick={closeMenu}>
                            <Typography tag="label">
                                <Translator tk="FAQ_BUTTON_TEXT" />
                            </Typography>
                        </Link>
                    </>
                ) : null}

                <Button onClick={this.onContactButtonClicked}>
                    <Typography tag="label">
                        <Translator tk="CONTACT_BUTTON_TEXT" />
                    </Typography>
                </Button>
                <Languages minimal />
                <Stores minimal />
                <AuthModal modalRef={this.createAuthModalRef} flow={FLOW_NAMES.SIGN_IN} />
            </Wrap>
        );
    }
}

Options.propTypes = {
    className: string,
    faqsLink: string,
    authTK: string,
    isLoggedIn: bool,
    logout: func,
    countryCode: string,
    storeCode: string,
    activeLanguage: string,
    isPartner: bool,
    requestOfferEnabled: bool,
};

Options.defaultProps = {
    className: '',
    faqsLink: '',
    authTK: '',
    isLoggedIn: false,
    logout: () => {},
    countryCode: '',
    storeCode: '',
    activeLanguage: '',
    isPartner: false,
    requestOfferEnabled: false,
};

export default withDixaMessenger(Options);
